import Dexie from 'dexie'

const db = new Dexie('BuildingPassportOffline')

db.version(1).stores({
  // Offline auth: cache one user's credentials for offline login
  auth: 'email, userId',
  // Task data: all assigned tasks cached for offline access
  tasks: 'id, status, buildingPassportId, projectId, updatedAt',
  // Reference data
  projects: 'id',
  teams: 'id',
  formTemplates: 'id',
  // Sync queue: mutations made offline, replayed when online
  syncQueue: '++id, type, status, createdAt',
  // Pending file uploads: compressed photo blobs waiting for sync
  pendingFiles: '++id, taskId, fieldKey, offlineFileId, status'
})

export const cacheTasksMerged = async tasks => {
  const list = Array.isArray(tasks) ? tasks : [tasks]
  const valid = list.filter(t => t && t.id != null)
  if (!valid.length) return
  await db.transaction('rw', db.tasks, async () => {
    const existing = await db.tasks.bulkGet(valid.map(t => t.id))
    const merged = valid.map((incoming, i) => {
      const current = existing[i]
      if (!current) return incoming
      if (current._offline) return current
      return { ...current, ...incoming }
    })
    await db.tasks.bulkPut(merged)
  })
}

export default db
